import React from 'react'

import { Root, useRoutes } from './Root'

export { useRoutes }

export const App: React.FC = () => <Root />
